export default __webpack_public_path__ + "static/media/Pop_Up.0cdb2247.png";